import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

// Tiny markdown renderer: headings, bold, lists, links, paragraphs. No XSS surface
// since this comes from our own backend constants.
function renderMarkdown(md) {
  const lines = md.split("\n");
  const out = [];
  let inList = false;
  let listBuf = [];
  const flushList = () => {
    if (inList) {
      out.push(<ul key={`ul-${out.length}`} className="list-disc pl-6 space-y-1 my-3">{listBuf}</ul>);
      listBuf = [];
      inList = false;
    }
  };
  const inline = (s) => {
    const parts = s.split(/(\*\*[^*]+\*\*|_[^_]+_)/g);
    return parts.map((p, i) => {
      const k = `${i}-${p.slice(0, 6)}`;
      if (p.startsWith("**") && p.endsWith("**")) return <strong key={k}>{p.slice(2, -2)}</strong>;
      if (p.startsWith("_") && p.endsWith("_")) return <em key={k} className="text-muted-foreground">{p.slice(1, -1)}</em>;
      return <React.Fragment key={k}>{p}</React.Fragment>;
    });
  };
  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (!line.trim()) { flushList(); return; }
    if (line.startsWith("# ")) { flushList(); out.push(<h1 key={`h1-${i}`} className="text-4xl mt-2">{inline(line.slice(2))}</h1>); return; }
    if (line.startsWith("## ")) { flushList(); out.push(<h2 key={`h2-${i}`} className="text-2xl mt-6">{inline(line.slice(3))}</h2>); return; }
    if (line.startsWith("### ")) { flushList(); out.push(<h3 key={`h3-${i}`} className="text-xl mt-4">{inline(line.slice(4))}</h3>); return; }
    if (line.startsWith("- ")) {
      inList = true;
      listBuf.push(<li key={`li-${i}`}>{inline(line.slice(2))}</li>);
      return;
    }
    flushList();
    out.push(<p key={`p-${i}`} className="leading-relaxed">{inline(line)}</p>);
  });
  flushList();
  return out;
}

function currentReleaseCopy(markdown) {
  return markdown;
}

export default function LegalPage() {
  const { doc } = useParams();
  const [md, setMd] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/legal/${doc}`)
      .then((r) => setMd(currentReleaseCopy(r.data.markdown || "")))
      .catch(() => setMd("# HAEVEN Legal\n\nLegal information is temporarily unavailable. Please visit haeven.world or contact support@haeven.world."))
      .finally(() => setLoading(false));
  }, [doc]);

  return (
    <div className="min-h-screen bg-background grain px-4 py-10" data-testid={`legal-page-${doc}`}>
      <div className="max-w-2xl mx-auto">
        <Link to="/" data-testid="legal-back-btn" className="brutal-btn inline-flex items-center gap-2 px-3 py-2 bg-card mb-6">
          <ArrowLeft size={14} strokeWidth={2.5} /> Back
        </Link>
        <article className="brutal-card bg-card p-6 md:p-10 space-y-1">
          {loading ? <p>Loading…</p> : renderMarkdown(md)}
        </article>
      </div>
    </div>
  );
}
